// Reliable smooth-scroll to an anchor, accounting for the fixed header.
// window.scrollTo is more robust than scrollIntoView on mobile browsers.
export function scrollToId(target) {
  const el = document.querySelector(target);
  if (!el) return;
  const offset = 72; // fixed header height
  const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top, behavior: "smooth" });
}
